import { axios } from '@/lib/axios';

export const getPromiseTime = async (location_id: string, order_type_id: string, date: string) => {
    const { data } = await axios.get(
        `v1/get-promise-time/${location_id}/${order_type_id}?date=${date}`
    );
    return data.times;
};
